
import dClient, {clientNoLoader} from './../../Components/api/reduxLoaderApi';

import { setProductForm, setProduct, setProductTypes} from "./slice";
import failStatus from "../../Components/utils/failStatus";
import {notification} from "../../Components/functions/notification/notificationFunction";
import React from "react";
import {setUsers} from "../user/userSlice";


export const getProducts = (x, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient('get', 'product', {}, {},2, false);
    // if (failStatus(res)) return '';
    dispatch(setProduct(res.data));
    return callback && callback(res);
};

export const deleteProduct = ({ product_id }, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'delete',
        `product/${product_id}`,
        {},
        {},
        2,
        true,
    );
    // if (failStatus(res)) return '';
    // dispatch(getProducts());
    return callback && callback(res);
};

export const getProductById = ({ slug }, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `product/${slug}`,
        {},
        {},
        2,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(setProductForm(res?.data?.product));
    return callback && callback(res?.data?.product?.attributes);
};


export const getProductsByName = (x, callback = false) => async (
    dispatch,
    getState,
) => {
    const products = getState().product.products;
    const res = await clientNoLoader('get', `product?q=${x}`, {}, {},2, false);
    if (failStatus(res, dispatch)) return '';
    dispatch(setProduct([...products,...res.data.data]));
    return callback && callback(res);
};

export const getProductType = (x, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `product-type`,
        {},
        {},
        1,
        true,
    );
    // if (failStatus(res)) return '';
    dispatch(setProductTypes(res.data.data));
    return callback && callback(res.data.data[0]);
};

export const createProduct = ( data, callback= false ) => async (
    dispatch, getState
) => {
    const res = await dClient(
        'post',
        `product`,
        data,
        {},
        2,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
}

export const editProduct = ( id, data, callback= false ) => async (
    dispatch, getState
) => {
    const res = await dClient(
        'post',
        `product/${id}`,
        data,
        {},
        2,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ویرایش شد</h3>, false))
    return callback && callback();
}

export const getProductsByIds = ( allIds, callback= false ) => async (
    dispatch, getState
) => {

    let ids = "";
    allIds.map((item,i)=>{
        ids = ids+ `ids[${i}]=${item}&`
    })
    const res = await dClient(
        'get',
        `product?${ids}page=1&per_page=12`,
        {},
        {},
        2,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(setProduct(res.data.data));
    return callback && callback();
}
